// Pure helpers for the Report Assistant's voice call (ReportAssistantPanel.js),
// kept out of the component so scripts/test-report-assistant.mjs can drive them.

// How a call ended, from Vapi's endedReason (status-update message) and whether
// he tapped End himself:
//   'finished' — he hung up, or the assistant ended the call at the wrap-up;
//                the session is closed (assistant-voice-end).
//   'dropped'  — anything else (screen locked, tab hidden, network, silence, an
//                unknown reason): the session stays open and the panel says
//                "Call ended - tap Talk to pick up where you left off."
// Unknown reasons count as a drop on purpose: offering to pick up costs nothing.
const FINISHED_REASONS = new Set([
  'customer-ended-call',
  'assistant-ended-call',
  'assistant-said-end-call-phrase',
  'assistant-ended-call-with-hangup-task',
  'assistant-ended-call-after-message-spoken',
])
export function callOutcome({ userEnded = false, endedReason = null } = {}) {
  if (userEnded) return 'finished'
  return FINISHED_REASONS.has(String(endedReason || '')) ? 'finished' : 'dropped'
}

// The body for POST ?action=assistant-voice-start. A second call in the same
// panel is a RESUME: it sends the CURRENT on-screen form (never the one the first
// call started with), the open session to reuse if there is one, and the tail of
// the spoken transcript so the assistant does not start over.
export const RESUME_TRANSCRIPT_LINES = 30
export function voiceStartBody({ reportId, form, hadCall = false, openSessionId = null, lines = [] }) {
  const body = { report_id: reportId, form }
  if (!hadCall) return body
  body.resume = true
  if (openSessionId) body.resume_session_id = openSessionId
  body.transcript = (Array.isArray(lines) ? lines : [])
    .filter(l => l && (l.role === 'user' || l.role === 'assistant') && typeof l.content === 'string' && l.content.trim())
    .slice(-RESUME_TRANSCRIPT_LINES)
    .map(l => ({ role: l.role, content: l.content.slice(0, 500) }))
  return body
}

// Screen Wake Lock is available (iPadOS / iOS Safari 16.4+, Chrome, Edge).
export const wakeLockSupported = (nav = typeof navigator === 'undefined' ? undefined : navigator) =>
  !!(nav && nav.wakeLock && typeof nav.wakeLock.request === 'function')
